var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import FormInputRegular from '@marketing/components/funnel/FormFields/FormInputRegular';
import { Asterisk } from '@marketing/components/funnel/Icons/Icons';
import { useProfileContext } from '@marketing/profile/ProfileContext';
import { ProfileFormLayout, ProfileFormMain } from '@marketing/profile/common/ProfileFormLayout';
import { trackCompleteContact, trackProfileStart } from '@marketing/profile/trackers';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { isValidFullName, validateEmailAddress } from '@utils/form_validations';
import { formatArrayCommaString } from '@utils/formatting_utils';
var ContactInfoForm = function () {
    var navigate = useNavigate();
    var _a = useProfileContext(), profileData = _a.profileData, saveProfile = _a.saveProfile, profileBasePath = _a.profileBasePath, setFacebookSubscribeEventProps = _a.setFacebookSubscribeEventProps, trackProfileInteractionEvent = _a.trackProfileInteractionEvent;
    var _b = useState(profileData.customerName || ''), customerName = _b[0], setCustomerName = _b[1];
    var _c = useState(profileData.email || ''), email = _c[0], setEmail = _c[1];
    var _d = useState(true), isValid = _d[0], setIsValid = _d[1];
    useEffect(function () {
        trackProfileStart(profileData, setFacebookSubscribeEventProps);
    }, []);
    useEffect(function () {
        var isNameValid = validateCustomerName(customerName).isValid;
        var isEmailValid = validateEmailAddress(email).isValid;
        setIsValid(isNameValid && isEmailValid);
    }, [customerName, email]);
    var handleCustomerNameChange = function (value) {
        setCustomerName(value);
    };
    var validateCustomerName = function (value) {
        var isValid = isValidFullName(value);
        var result = isValid
            ? { isValid: true, error: '' }
            : { isValid: false, error: 'Please enter your first and last name' };
        setIsValid(isValid);
        return result;
    };
    var handleEmailChange = function (value) {
        setEmail(value);
    };
    var validateEmail = function (value) {
        var result = validateEmailAddress(value);
        setIsValid(result.isValid);
        return !result.isValid ? __assign(__assign({}, result), { error: 'Please enter a valid email address' }) : result;
    };
    var handleClickPrevious = function () {
        navigate("".concat(profileBasePath, "/addons"), { viewTransition: true });
    };
    var handleSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var data, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    if (!isValid) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, saveProfile({ customerName: customerName, email: email })];
                case 2:
                    data = _a.sent();
                    trackCompleteContact(data);
                    trackProfileInteractionEvent('email_added');
                    navigate("".concat(profileBasePath, "/address"), { viewTransition: true });
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error('Error saving profile:', error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var petNamesStr = profileData.pets.length < 3
        ? "".concat(formatArrayCommaString(profileData.pets.map(function (pet) { return pet.name; })), "\u2019s")
        : 'your dogs’';
    var formId = 'contact-info-form';
    return (_jsx(ProfileFormLayout, __assign({ disableNext: !customerName || !email || !isValid, formId: formId, handleClickPrevious: handleClickPrevious }, { children: _jsx(ProfileFormMain, __assign({ h1: "Nom Nom Sign Up: Contact Information" }, { children: _jsxs("div", __assign({ className: "grid grid-cols-1 gap-16" }, { children: [_jsxs("div", __assign({ className: "text-center grid grid-cols-1 gap-8" }, { children: [_jsx("h2", __assign({ className: "font-medium" }, { children: "Tell Us About Yourself" })), _jsxs("p", { children: ["Save ", petNamesStr, " flexible meal plan by providing your contact details."] }), _jsxs("div", { children: [_jsx("span", __assign({ className: "inline-block mr-2" }, { children: _jsx(Asterisk, {}) })), _jsx("span", __assign({ className: "inline-block" }, { children: "= required fields" }))] })] })), _jsxs("form", __assign({ id: formId, onSubmit: handleSubmit, className: "w-full grid grid-cols-1 gap-8" }, { children: [_jsx(FormInputRegular, { autoComplete: "full-name", debounceTimeout: 300, id: "customer-name", label: "First and Last Name", onInputChange: handleCustomerNameChange, validate: validateCustomerName, value: customerName }), _jsx(FormInputRegular, { autoComplete: "email", debounceTimeout: 300, id: "email", label: "Email Address", type: "email", onInputChange: handleEmailChange, validate: validateEmail, value: email })] })), _jsxs("p", { children: ["By continuing, you agree to receive special offers, product updates, news, and other marketing emails from Nom Nom and its Mars Petcare affiliates in accordance with our", ' ', _jsx("a", __assign({ className: "font-bold underline", href: "https://www.mars.com/privacy", target: "_blank", rel: "noreferrer" }, { children: "Privacy Policy" })), ". You may unsubscribe at any time."] })] })) })) })));
};
export default ContactInfoForm;
